module.exports = __webpack_public_path__ + "img/fm-f-Path 49 Copy@3x.d4b51965.png";